import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import ContactCta from '../components/contact-cta'
import Footer from '../components/footer'
import './your-global-representative.css'

const YourGlobalRepresentative = (props) => {
  return (
    <div className="your-global-representative-container10">
      <Helmet>
        <title>
          Your-Global-Representative - only one 0603 1505 of 04.03 16:42 Copy of
          25.02 14:40 Chubby Hasty Hippopotamus
        </title>
        <meta
          property="og:title"
          content="Your-Global-Representative - only one 0603 1505 of 04.03 16:42 Copy of 25.02 14:40 Chubby Hasty Hippopotamus"
        />
        <link
          rel="canonical"
          href="https://copy-of-copy-of-0403-1642-copy-of-2502-1440-chubby-h-d8xxy3.teleporthq.site/your-global-representative"
        />
        <meta
          property="og:url"
          content="https://copy-of-copy-of-0403-1642-copy-of-2502-1440-chubby-h-d8xxy3.teleporthq.site/your-global-representative"
        />
      </Helmet>
      <Navigation
        button={
          <Fragment>
            <span className="your-global-representative-text10">Button</span>
          </Fragment>
        }
        button1={
          <Fragment>
            <span className="your-global-representative-text11">Button</span>
          </Fragment>
        }
        rootClassName="navigationroot-class-name"
      ></Navigation>
      <section className="your-global-representative-thq-representation-section-elm representation-section">
        <section className="global-rep-hero">
          <div className="hero-container">
            <div className="hero-content-wrapper">
              <div className="hero-badge">
                <span className="your-global-representative-badge-icon badge-icon">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 20 20"
                  ></svg>
                </span>
                <span className="your-global-representative-badge-text">
                  Your Voice in Global Markets
                </span>
              </div>
              <h1 className="hero-headline">
                <span>
                  {' '}
                  Your Global Representative:
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="your-global-representative-thq-text-accent-span-elm">
                  We Speak for You,
                </span>
                <span>
                  {' '}
                  So You Don&apos;t Have to Travel
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h1>
              <p className="hero-subheadline">
                Beyond logistics. We act as your authorized representative on
                the ground—negotiating deals, inspecting shipments, and managing
                every document, so you can focus on growing your business from
                home.
              </p>
              <div className="your-global-representative-hero-cta-group3 hero-cta-group">
                <a href="#ContactCta">
                  <div className="your-global-representative-thq-btn-primary-custom-elm btn-primary-custom">
                    <span>Partner With Us</span>
                  </div>
                </a>
                <Link to="/services">
                  <div className="your-global-representative-thq-btn-outline-custom-elm btn-outline-custom">
                    <span>Explore Services</span>
                  </div>
                </Link>
              </div>
              <div className="trust-indicators">
                <div className="trust-item your-global-representative-trust-item">
                  <div className="trust-icon-box">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                        <path d="m9 12l2 2l4-4"></path>
                      </g>
                    </svg>
                  </div>
                  <span className="trust-label">Authorized Legal Agent</span>
                </div>
                <div className="trust-item your-global-representative-trust-item">
                  <div className="trust-icon-box">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M14.364 13.634a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506l4.013-4.009a1 1 0 0 0-3.004-3.004zm.123-5.776A1 1 0 0 1 14 7V2"></path>
                        <path d="M20 19.645V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l2.516 2.516M8 18h1"></path>
                      </g>
                    </svg>
                  </div>
                  <span className="trust-label">Direct Negotiations</span>
                </div>
              </div>
            </div>
            <div className="hero-visual-wrapper">
              <div className="image-frame">
                <img
                  alt="Global Business Handshake"
                  src="https://images.pexels.com/photos/8939056/pexels-photo-8939056.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="hero-main-image"
                />
                <div className="floating-data-card top-right">
                  <div className="stat-circle">
                    <span>100%</span>
                  </div>
                  <div className="stat-text">
                    <span>On-Ground Presence</span>
                  </div>
                </div>
                <div className="bottom-left floating-data-card">
                  <div className="pulse-ring"></div>
                  <div className="stat-text">
                    <span>Local Representation</span>
                  </div>
                </div>
              </div>
              <div className="geometric-decoration"></div>
            </div>
          </div>
        </section>
        <div className="your-global-representative-container11">
          <div className="your-global-representative-container12">
            <Script
              html={`<style>
        @keyframes float {0%,100% {transform: translate(-50%, -50%);}
50% {transform: translate(-50%, -60%);}}@keyframes pulse {0% {transform: scale(1);
opacity: 0.8;}
100% {transform: scale(3);
opacity: 0;}}@keyframes dash {to {stroke-dashoffset: -100;}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container13">
          <div className="your-global-representative-container14">
            <Script
              html={`<script>
(function(){
  // Simple interaction to highlight map nodes on hover of text or other triggers
  const nodes = document.querySelectorAll(".floating-data-node")
  nodes.forEach((node) => {
    node.addEventListener("mouseenter", () => {
      node.style.transform = "scale(1.1)"
      node.style.borderColor = "var(--color-accent)"
    })
    node.addEventListener("mouseleave", () => {
      node.style.transform = "scale(1)"
      node.style.borderColor = "rgba(255, 255, 255, 0.1)"
    })
  })
})()
</script>`}
            ></Script>
          </div>
        </div>
        <div className="representation-container">
          <header className="representation-header">
            <div className="badge-container">
              <span className="page-strategic-hero-badge strategic-hero-badge">
                Full-Cycle Representation
              </span>
            </div>
            <h2 className="page-strategic-hero-headline strategic-hero-headline">
              <span>
                {' '}
                We Go Where You Can&apos;t.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                {' '}
                We Do What You&apos;d Do—
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="your-global-representative-thq-text-accent-elm1">
                Only Better.
              </span>
            </h2>
            <p className="strategic-hero-subheadline page-strategic-hero-subheadline">
              From the first handshake to the final delivery, we act in your
              name and protect your interests at every step.
            </p>
          </header>
          <div className="comparison-grid">
            <div className="comparison-track">
              <div className="client-side comparison-card">
                <div className="image-wrapper">
                  <img
                    alt="Client at Desk"
                    src="https://images.pexels.com/photos/530024/pexels-photo-530024.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    className="split-image"
                  />
                  <div className="image-overlay client-overlay"></div>
                  <div className="label-tag">
                    <span>Your Office</span>
                  </div>
                </div>
                <div className="card-content">
                  <h3 className="side-title">Strategy &amp; Oversight</h3>
                  <p className="side-text">
                    You maintain control and focus on growth while we execute
                    the ground-level complexities of your supply chain.
                  </p>
                </div>
              </div>
              <div className="connection-hub">
                <div className="pulse-line"></div>
                <div className="hub-icon">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"></path>
                  </svg>
                </div>
                <div className="pulse-line"></div>
              </div>
              <div className="comparison-card agent-side">
                <div className="image-wrapper">
                  <img
                    alt="Agent at Factory"
                    src="https://images.pexels.com/photos/35383622/pexels-photo-35383622.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    className="split-image"
                  />
                  <div className="image-overlay agent-overlay"></div>
                  <div className="label-tag">
                    <span>On-Site Presence</span>
                  </div>
                </div>
                <div className="card-content">
                  <h3 className="side-title">Expert Execution</h3>
                  <p className="side-text">
                    Our agents are your eyes and ears on the factory floor,
                    ensuring compliance and quality in real-time.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="features-grid">
            <div className="page-feature-item">
              <div className="feature-icon-box">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"></path>
                </svg>
              </div>
              <div className="feature-text">
                <h4 className="feature-title">Supplier Visits &amp; Audits</h4>
                <p className="feature-description">
                  We travel to factories and farms to verify capabilities,
                  inspect facilities, and ensure your partner is reliable before
                  you commit.
                </p>
              </div>
            </div>
            <div className="page-feature-item">
              <div className="feature-icon-box">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="m9 14l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="feature-text">
                <h4 className="feature-title">Cargo Supervision</h4>
                <p className="feature-description">
                  Our team is present during loading and stuffing to verify
                  quantities, check packaging, and document the process with
                  photos and reports.
                </p>
              </div>
            </div>
            <div className="page-feature-item">
              <div className="feature-icon-box">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="feature-text">
                <h4 className="feature-title">Quality Checks</h4>
                <p className="feature-description">
                  We conduct basic quality assessments and coordinate with
                  third-party inspectors if deeper certification is required.
                </p>
              </div>
            </div>
            <div className="page-feature-item">
              <div className="feature-icon-box">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                    <circle r="2" cx="17" cy="18"></circle>
                    <circle r="2" cx="7" cy="18"></circle>
                  </g>
                </svg>
              </div>
              <div className="feature-text">
                <h4 className="feature-title">Shipment Coordination</h4>
                <p className="feature-description">
                  We manage the entire loading process, ensuring your cargo is
                  handled correctly and departs on schedule.
                </p>
              </div>
            </div>
          </div>
          <div className="action-footer">
            <a
              href="#ContactCta"
              className="your-global-representative-thq-btn-elm btn-primary btn btn-xl"
            >
              <span>Request Site Inspection</span>
            </a>
          </div>
        </div>
        <div className="your-global-representative-container15">
          <div className="your-global-representative-container16">
            <Script
              html={`<style>
        @keyframes pulse {0% {transform: scale(0.95);
box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);}
70% {transform: scale(1);
box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);}
100% {transform: scale(0.95);
box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);}}@keyframes float {0%,100% {transform: translateY(0);}
50% {transform: translateY(-10px);}}@keyframes drawLine {to {stroke-dashoffset: 0;}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container17">
          <div className="your-global-representative-container18">
            <Script
              html={`<script>
(function(){
  // Simple parallax effect for the map container
  const heroSection = document.querySelector(".strategic-hero")
  const mapWrapper = document.querySelector(".strategic-map-wrapper")

  if (heroSection && mapWrapper) {
    heroSection.addEventListener("mousemove", (e) => {
      const xAxis = (window.innerWidth / 2 - e.pageX) / 40
      const yAxis = (window.innerHeight / 2 - e.pageY) / 40

      // Smoothly apply rotation while keeping the original perspective
      mapWrapper.style.transform = \`rotateY(\${xAxis - 5}deg) rotateX(\${yAxis + 5}deg)\`
    })

    // Reset rotation on mouse leave
    heroSection.addEventListener("mouseleave", () => {
      mapWrapper.style.transition = "all 0.5s ease"
      mapWrapper.style.transform = \`rotateY(-5deg) rotateX(5deg)\`

      setTimeout(() => {
        mapWrapper.style.transition = "none"
      }, 500)
    })
  }
})()
</script>`}
            ></Script>
          </div>
        </div>
        <section className="negotiation-section">
          <div className="negotiation-bg-wrapper">
            <video
              src="https://videos.pexels.com/video-files/3129785/3129785-hd_1920_1080_25fps.mp4"
              loop="true"
              muted="true"
              autoPlay="true"
              playsInline="true"
              className="negotiation-video"
            ></video>
            <div className="negotiation-overlay"></div>
          </div>
          <div className="negotiation-container">
            <div className="negotiation-grid">
              <div className="negotiation-content">
                <div className="negotiation-badge">
                  <span className="badge-icon">
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></svg>
                  </span>
                  <span>
                    {' '}
                    Global Communication
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
                <h2 className="negotiation-headline">
                  We Speak Their Language—So You Don&apos;t Have to Wonder What
                  Was Said
                </h2>
                <p className="negotiation-subheadline">
                  Cross-cultural deals succeed when communication is clear. Our
                  team handles negotiations, correspondence, and conflict
                  resolution in English, Chinese, Spanish, Portuguese, Russian,
                  and more.
                </p>
                <div className="points-grid">
                  <div id="point-1" className="point-card">
                    <div className="point-icon-box">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <circle r="4" cx="9" cy="7"></circle>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                    </div>
                    <div className="point-text">
                      <h3 className="point-title">Commercial Negotiations</h3>
                      <p className="point-desc">
                        We negotiate pricing, terms, and Incoterms directly with
                        suppliers or buyers on your behalf.
                      </p>
                    </div>
                  </div>
                  <div id="point-2" className="point-card">
                    <div className="point-icon-box">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m5 8 6 6"></path>
                        <path d="m4 14 6-6 2-3"></path>
                        <path d="M2 5h12"></path>
                        <path d="M7 2h1"></path>
                        <path d="m22 22-5-10-5 10"></path>
                        <path d="M14 18h6"></path>
                      </svg>
                    </div>
                    <div className="point-text">
                      <h3 className="point-title">Native-Level Fluency</h3>
                      <p className="point-desc">
                        Our team includes native speakers who understand
                        cultural nuances and unspoken rules.
                      </p>
                    </div>
                  </div>
                  <div id="point-3" className="point-card">
                    <div className="point-icon-box">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                        <path d="M8 9h8"></path>
                        <path d="M8 13h6"></path>
                      </svg>
                    </div>
                    <div className="point-text">
                      <h3 className="point-title">Real-Time Updates</h3>
                      <p className="point-desc">
                        Clear, jargon-free summaries of every conversation in
                        your preferred language.
                      </p>
                    </div>
                  </div>
                  <div id="point-4" className="point-card">
                    <div className="point-icon-box">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                    </div>
                    <div className="point-text">
                      <h3 className="point-title">Conflict Resolution</h3>
                      <p className="point-desc">
                        We mediate and protect your position before small issues
                        become costly problems.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="negotiation-visual">
                <div className="map-stage">
                  <div className="floating-bubbles">
                    <div className="bubble-1 bubble">
                      <span>你好</span>
                    </div>
                    <div className="bubble-2 bubble">
                      <span>Hola</span>
                    </div>
                    <div className="bubble bubble-3">
                      <span>Hello</span>
                    </div>
                    <div className="bubble-4 bubble">
                      <span>Olá</span>
                    </div>
                    <div className="bubble-5 bubble">
                      <span>Привет</span>
                    </div>
                  </div>
                  <div className="map-connection-lines">
                    <svg viewBox="0 0 400 300" className="connection-svg">
                      <path
                        d="M50,150 Q200,50 350,150"
                        className="path-1 path-line"
                      ></path>
                      <path
                        d="M50,150 Q200,250 350,150"
                        className="path-2 path-line"
                      ></path>
                      <circle
                        r="5"
                        cx="50"
                        cy="150"
                        className="map-node"
                      ></circle>
                      <circle
                        r="5"
                        cx="350"
                        cy="150"
                        className="map-node"
                      ></circle>
                      <circle
                        r="3"
                        cx="200"
                        cy="100"
                        className="map-node node-pulse"
                      ></circle>
                    </svg>
                  </div>
                  <img
                    alt="Negotiation"
                    src="https://images.pexels.com/photos/6930300/pexels-photo-6930300.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    className="visual-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="your-global-representative-container19">
          <div className="your-global-representative-container20">
            <Script
              html={`<style>
        @keyframes float-bubble {0%,100% {transform: translateY(0) scale(1);
opacity: 0.9;}
50% {transform: translateY(-20px) scale(1.05);
opacity: 1;}}@keyframes draw-line {0% {stroke-dashoffset: 1000;}
50% {stroke-dashoffset: 0;}
100% {stroke-dashoffset: -1000;}}@keyframes pulse-node {0% {r: 3;
opacity: 1;}
100% {r: 10;
opacity: 0;}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container21">
          <div className="your-global-representative-container22">
            <Script
              html={`<script>
(function(){
  // Interaction for point cards to highlight visual elements
  const pointCards = [document.getElementById("point-1"), document.getElementById("point-2"), document.getElementById("point-3"), document.getElementById("point-4")]

  pointCards.forEach((card, index) => {
    if (card) {
      card.addEventListener("mouseenter", () => {
        // Highlight specific bubbles or nodes based on card hovered
        const bubbles = document.querySelectorAll(".bubble")
        bubbles.forEach((b, i) => {
          if (i === index) {
            b.style.transform = "scale(1.4)"
            b.style.zIndex = "10"
            b.style.background = "var(--color-accent)"
            b.style.color = "white"
          } else {
            b.style.opacity = "0.3"
          }
        })
      })

      card.addEventListener("mouseleave", () => {
        const bubbles = document.querySelectorAll(".bubble")
        bubbles.forEach((b) => {
          b.style.transform = ""
          b.style.zIndex = ""
          b.style.background = ""
          b.style.color = ""
          b.style.opacity = "0.9"
        })
      })
    }
  })

  // Parallax effect on bubbles based on mouse movement
  const visualStage = document.querySelector(".map-stage")
  if (visualStage) {
    visualStage.addEventListener("mousemove", (e) => {
      const bubbles = document.querySelectorAll(".bubble")
      const { width, height } = visualStage.getBoundingClientRect()
      const offX = (e.clientX - width / 2) / 25
      const offY = (e.clientY - height / 2) / 25

      bubbles.forEach((bubble, i) => {
        const speed = (i + 1) * 0.5
        bubble.style.transform = \`translate(\${offX * speed}px, \${offY * speed}px)\`
      })
    })

    visualStage.addEventListener("mouseleave", () => {
      const bubbles = document.querySelectorAll(".bubble")
      bubbles.forEach((bubble) => {
        bubble.style.transform = "translate(0, 0)"
      })
    })
  }
})()
</script>`}
            ></Script>
          </div>
        </div>
        <section className="doc-management-section">
          <div className="doc-container">
            <div className="doc-content-wrapper">
              <div className="doc-text-block">
                <div className="doc-badge">
                  <span>Global Compliance</span>
                </div>
                <h2 className="doc-headline">
                  <span>
                    {' '}
                    Your Paperwork, Perfected.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span className="your-global-representative-thq-doc-highlight-elm">
                    Every Language. Every Signature.
                  </span>
                </h2>
                <p className="doc-subheadline">
                  International trade runs on paper. We ensure every contract,
                  invoice, and certificate is accurate, compliant, and
                  professionally prepared in the required language.
                </p>
                <div className="doc-features-grid">
                  <div className="doc-feature-item">
                    <div className="doc-icon-box">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                      </svg>
                    </div>
                    <div className="doc-feature-text">
                      <h3 className="doc-feature-title">
                        Sales &amp; Purchase Contracts
                      </h3>
                      <p className="doc-feature-desc">
                        Expert drafting, review, and finalization of agreements
                        with global suppliers and buyers.
                      </p>
                    </div>
                  </div>
                  <div className="doc-feature-item">
                    <div className="doc-icon-box">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle r="10" cx="12" cy="12"></circle>
                        <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                      </svg>
                    </div>
                    <div className="doc-feature-text">
                      <h3 className="doc-feature-title">
                        Carrier &amp; Service Agreements
                      </h3>
                      <p className="doc-feature-desc">
                        Handling all contracts with freight forwarders, shipping
                        lines, and insurance providers.
                      </p>
                    </div>
                  </div>
                  <div className="doc-feature-item">
                    <div className="doc-icon-box">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m5 8l6 6m-7 0l6-6l2-3M2 5h12M7 2h1m14 20l-5-10l-5 10m2-4h6"></path>
                      </svg>
                    </div>
                    <div className="doc-feature-text">
                      <h3 className="doc-feature-title">
                        Multilingual Documentation
                      </h3>
                      <p className="doc-feature-desc">
                        Documents prepared in English, local languages, or
                        bilingual formats for local authorities.
                      </p>
                    </div>
                  </div>
                  <div className="doc-feature-item">
                    <div className="doc-icon-box">
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      </svg>
                    </div>
                    <div className="doc-feature-text">
                      <h3 className="doc-feature-title">
                        Export/Import Compliance
                      </h3>
                      <p className="doc-feature-desc">
                        Precise management of certificates of origin, licenses,
                        and complex permits.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="doc-cta-area">
                  <div className="doc-banking-support">
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M11 17h3v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3.16 3.16 0 0 0 2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1a5 5 0 0 0-2-4V3a4 4 0 0 0-3.2 1.6l-.3.4H11a6 6 0 0 0-6 6v1a5 5 0 0 0 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5-7h.01M2 8v1a2 2 0 0 0 2 2h1"></path>
                    </svg>
                    <span>
                      Legal &amp; Banking Support: Letters of credit and bank
                      documentation included.
                    </span>
                  </div>
                </div>
              </div>
              <div className="doc-visual-block">
                <div className="doc-visual-stack">
                  <div className="doc-card-main">
                    <div className="doc-card-header">
                      <div className="doc-lang-pills">
                        <span className="lang-pill active">EN</span>
                        <span className="lang-pill">CN</span>
                        <span className="lang-pill">ES</span>
                        <span className="lang-pill">AR</span>
                      </div>
                      <div className="doc-status-pill">
                        <span>Verified</span>
                      </div>
                    </div>
                    <div className="doc-card-body">
                      <div className="title doc-skeleton-line"></div>
                      <div className="doc-skeleton-line"></div>
                      <div className="doc-skeleton-line"></div>
                      <div className="short doc-skeleton-line"></div>
                      <div className="doc-skeleton-line"></div>
                      <div className="doc-skeleton-line"></div>
                      <div className="doc-signature-area">
                        <div className="sign doc-skeleton-line"></div>
                        <div className="doc-stamp-circle">
                          <span>APPROVED</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="float-1 doc-card-floating">
                    <div className="float-icon">
                      <svg
                        fill="none"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                        <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                      </svg>
                    </div>
                    <div className="float-text">
                      <span>Bill of Lading</span>
                    </div>
                  </div>
                  <div className="float-2 doc-card-floating">
                    <div className="float-icon">
                      <svg
                        fill="none"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      </svg>
                    </div>
                    <div className="float-text">
                      <span>Customs Permit</span>
                    </div>
                  </div>
                  <div className="doc-image-bg">
                    <img
                      alt="Professional Documentation"
                      src="https://images.pexels.com/photos/8205064/pexels-photo-8205064.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1200"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="your-global-representative-container23">
          <div className="your-global-representative-container24">
            <Script
              html={`<style>
        @keyframes float {0%,100% {transform: translateY(0);}
50% {transform: translateY(-20px);}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container25">
          <div className="your-global-representative-container26">
            <Script
              html={`<script>
(function(){
  // Interactive Document Management Section
  const docCard = document.getElementById("doc-card-main")

  if (docCard) {
    docCard.addEventListener("mousemove", (e) => {
      const rect = docCard.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      const centerX = rect.width / 2
      const centerY = rect.height / 2

      const rotateX = (y - centerY) / 10
      const rotateY = (centerX - x) / 10

      docCard.style.transform = \`perspective(1000px) rotateX(\${rotateX}deg) rotateY(\${rotateY}deg) scale(1.02)\`
    })

    docCard.addEventListener("mouseleave", () => {
      docCard.style.transform = \`perspective(1000px) rotateX(5deg) rotateY(-5deg) scale(1)\`
    })
  }

  // Simple language pill toggle simulation
  const pills = document.querySelectorAll(".lang-pill")
  pills.forEach((pill) => {
    pill.addEventListener("click", () => {
      pills.forEach((p) => p.classList.remove("active"))
      pill.classList.add("active")

      // Animate lines to simulate content changing
      const lines = document.querySelectorAll(".doc-skeleton-line")
      lines.forEach((line) => {
        line.style.opacity = "0.3"
        setTimeout(() => {
          line.style.opacity = "1"
        }, 300)
      })
    })
  })
})()
</script>`}
            ></Script>
          </div>
        </div>
        <section id="one-stop-advantage" className="advantage-section">
          <div className="advantage-video-container">
            <video
              src="https://videos.pexels.com/video-files/15547447/15547447-hd_1920_1080_24fps.mp4"
              loop="true"
              muted="true"
              autoPlay="true"
              playsInline="true"
              className="advantage-video"
            ></video>
            <div className="advantage-overlay"></div>
          </div>
          <div className="advantage-content-wrapper">
            <div className="advantage-header">
              <div className="advantage-badge">
                <span className="badge-icon">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></svg>
                </span>
                <span className="badge-text">The One-Stop Advantage</span>
              </div>
              <h2 className="advantage-headline">
                <span>
                  {' '}
                  One Partner. One Point of Contact.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span className="your-global-representative-thq-text-accent-elm2">
                  Total Peace of Mind.
                </span>
              </h2>
              <p className="advantage-subheadline">
                No more juggling translators, agents, forwarders, and
                inspectors. Waterside is your single, integrated team for trade
                representation, logistics, and documentation.
              </p>
            </div>
            <div className="advantage-grid">
              <div className="advantage-visual-box">
                <div className="image-mask">
                  <img
                    alt="Professional Partnership"
                    src="https://images.pexels.com/photos/4483559/pexels-photo-4483559.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    className="advantage-image"
                  />
                </div>
                <div className="experience-card">
                  <div className="experience-number">
                    <span>24/7</span>
                  </div>
                  <div className="experience-label">
                    <span>Global Support</span>
                  </div>
                </div>
              </div>
              <div className="advantage-text-box">
                <div className="summary-card">
                  <p className="summary-text">
                    <span>
                      {' '}
                      You stay home.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="your-global-representative-text41">
                      We go global.
                    </span>
                    <span>
                      {' '}
                      While you focus on your core business—sales, production,
                      strategy—we manage the entire international front.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </p>
                  <div className="page-process-steps">
                    <div className="page-process-step">
                      <div className="step-icon-box">
                        <svg
                          fill="none"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                          <circle r="4" cx="9" cy="7"></circle>
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                      </div>
                      <div className="step-info">
                        <h4 className="page-step-title">Finding Partners</h4>
                        <p className="step-desc">
                          Strategic sourcing and vetting.
                        </p>
                      </div>
                    </div>
                    <div className="page-process-step">
                      <div className="step-icon-box">
                        <svg
                          fill="none"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                      </div>
                      <div className="step-info">
                        <h4 className="page-step-title">Shaking Hands</h4>
                        <p className="step-desc">
                          Negotiation and deal closure.
                        </p>
                      </div>
                    </div>
                    <div className="page-process-step">
                      <div className="step-icon-box">
                        <svg
                          fill="none"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                          <polyline points="22 4 12 14.01 9 11.01"></polyline>
                        </svg>
                      </div>
                      <div className="step-info">
                        <h4 className="page-step-title">Final Delivery</h4>
                        <p className="step-desc">Inspected and documented.</p>
                      </div>
                    </div>
                  </div>
                  <p className="summary-footer">
                    <span>
                      {' '}
                      From finding the right partner to shaking hands on the
                      deal, from inspecting the cargo to handing you the final
                      delivery documents,
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="your-global-representative-text44">
                      we are your boots on the ground and your pen on the
                      contract.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="your-global-representative-container27">
          <div className="your-global-representative-container28">
            <Script
              html={`<style>
        @keyframes float {0%,100% {transform: translateY(0);}
50% {transform: translateY(-10px);}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container29">
          <div className="your-global-representative-container30">
            <Script
              html={`<script>
(function(){
  // Scroll animation reveal
  const observerOptions = {
    threshold: 0.1,
  }

  const advantageObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  const contentWrapper = document.getElementById("one-stop-advantage")
  if (contentWrapper) {
    const sections = contentWrapper.querySelectorAll(".advantage-header, .advantage-visual-box, .advantage-text-box")
    sections.forEach((section) => {
      section.style.opacity = "0"
      section.style.transform = "translateY(30px)"
      section.style.transition = "all 0.8s cubic-bezier(0.4, 0, 0.2, 1)"
      advantageObserver.observe(section)
    })
  }
})()
</script>`}
            ></Script>
          </div>
        </div>
        <section id="cta-representative" className="cta-representation-wrapper">
          <div className="cta-background-decoration">
            <div className="orb-1 glow-orb"></div>
            <div className="orb-2 glow-orb"></div>
          </div>
          <div className="cta-container">
            <div className="cta-content-grid">
              <div className="cta-text-content">
                <div className="cta-badge">
                  <span className="badge-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    ></svg>
                  </span>
                  <span>
                    {' '}
                    Global Presence, Local Expertise
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </div>
                <h2 className="cta-headline">
                  <span>
                    {' '}
                    Ready to Stop Traveling and
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="your-global-representative-thq-text-highlight-elm">
                    Start Growing?
                  </span>
                </h2>
                <p className="cta-subheadline">
                  Stop managing time zones and start scaling your operations.
                  Let&apos;s discuss how we can represent your interests
                  anywhere in the world with a dedicated specialist.
                </p>
                <div className="cta-actions">
                  <a
                    href="#ContactCta"
                    id="cta-main-btn"
                    className="your-global-representative-thq-btn-primary-elm btn-primary cta-button btn-xl"
                  >
                    <span>Contact Your Dedicated Representative</span>
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7l-7 7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </a>
                  <div className="cta-trust-indicators">
                    <div className="trust-item">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                          <circle r="4" cx="9" cy="7"></circle>
                        </g>
                      </svg>
                      <span>1:1 Dedicated Support</span>
                    </div>
                    <div className="trust-item">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle r="10" cx="12" cy="12"></circle>
                          <path d="m12 16l4-4l-4-4m-4 4h8"></path>
                        </g>
                      </svg>
                      <span>Response within 2 hours</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cta-visual-container">
                <div className="image-stack">
                  <div className="image-card main-image">
                    <img
                      alt="Friendly professional team collaborating"
                      src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=500"
                    />
                    <div className="image-overlay-card">
                      <div className="avatar-group">
                        <div className="avatar"></div>
                        <div className="avatar"></div>
                        <div className="avatar"></div>
                        <div className="avatar-plus">
                          <span>+12</span>
                        </div>
                      </div>
                      <p className="overlay-text">Your global team is ready.</p>
                    </div>
                  </div>
                  <div className="floating-stat-card">
                    <div className="stat-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M21.54 15H17a2 2 0 0 0-2 2v4.54M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05"></path>
                          <circle r="10" cx="12" cy="12"></circle>
                        </g>
                      </svg>
                    </div>
                    <div>
                      <div className="page-stat-value">
                        <span>50+</span>
                      </div>
                      <div className="page-stat-label">
                        <span>Countries Covered</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ContactCta
          btn={
            <Fragment>
              <span className="your-global-representative-text53">
                Request My Solution
              </span>
            </Fragment>
          }
          text={
            <Fragment>
              <span className="your-global-representative-text54">
                15+ Years Expertise
              </span>
            </Fragment>
          }
          sectionTitle={
            <Fragment>
              <span className="your-global-representative-text55">
                Get Your Personalized Solution
              </span>
            </Fragment>
          }
          rootClassName="contact-ctaroot-class-name3"
          sectionContent={
            <Fragment>
              <span className="your-global-representative-text56">
                Connect with our Dedicated Trade Specialists to request a
                tailored End-to-End Solution for your business.
              </span>
            </Fragment>
          }
        ></ContactCta>
        <Footer
          footerId="Footer"
          rootClassName="footerroot-class-name1"
        ></Footer>
        <div className="your-global-representative-container32">
          <div className="your-global-representative-container33">
            <Script
              html={`<style>
        @keyframes float {0%,100% {transform: translateY(0);}
50% {transform: translateY(-10px);}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container34">
          <div className="your-global-representative-container35">
            <Script
              html={`<script>
(function(){
  // Handle CTA button interaction
  const ctaBtn = document.getElementById("cta-main-btn")

  if (ctaBtn) {
    ctaBtn.addEventListener("click", () => {
      // Visual feedback on click
      ctaBtn.style.transform = "scale(0.95)"
      setTimeout(() => {
        ctaBtn.style.transform = ""
        console.log("Representative contact initiated")
        // In a real scenario, this would open a modal or scroll to a form
      }, 150)
    })
  }

  // Subtle parallax effect on the floating elements
  window.addEventListener("mousemove", (e) => {
    const statCard = document.querySelector(".floating-stat-card")
    const overlayCard = document.querySelector(".image-overlay-card")

    if (statCard && overlayCard) {
      const moveX = (e.clientX - window.innerWidth / 2) * 0.01
      const moveY = (e.clientY - window.innerHeight / 2) * 0.01

      statCard.style.transform = \`translate(\${moveX}px, \${moveY}px)\`
      overlayCard.style.transform = \`translate(\${-moveX}px, \${-moveY}px)\`
    }
  })
})()
</script>`}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container36">
          <div className="your-global-representative-container37">
            <Script
              html={`<style>
        @keyframes pulse {0% {transform: scale(0.95);
box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);}
70% {transform: scale(1);
box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);}
100% {transform: scale(0.95);
box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);}}@keyframes float {0%,100% {transform: translateY(0);}
50% {transform: translateY(-10px);}}@keyframes drawLine {to {stroke-dashoffset: 0;}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container38">
          <div className="your-global-representative-container39">
            <Script
              html={`<script>
(function(){
  // Simple parallax effect for the map container
  const heroSection = document.querySelector(".strategic-hero")
  const mapWrapper = document.querySelector(".strategic-map-wrapper")

  if (heroSection && mapWrapper) {
    heroSection.addEventListener("mousemove", (e) => {
      const xAxis = (window.innerWidth / 2 - e.pageX) / 40
      const yAxis = (window.innerHeight / 2 - e.pageY) / 40

      // Smoothly apply rotation while keeping the original perspective
      mapWrapper.style.transform = \`rotateY(\${xAxis - 5}deg) rotateX(\${yAxis + 5}deg)\`
    })

    // Reset rotation on mouse leave
    heroSection.addEventListener("mouseleave", () => {
      mapWrapper.style.transition = "all 0.5s ease"
      mapWrapper.style.transform = \`rotateY(-5deg) rotateX(5deg)\`

      setTimeout(() => {
        mapWrapper.style.transition = "none"
      }, 500)
    })
  }
})()
</script>`}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container40">
          <div className="your-global-representative-container41">
            <Script
              html={`<style>
        @keyframes float {0%,100% {transform: translate(-50%, -50%);}
50% {transform: translate(-50%, -60%);}}@keyframes pulse {0% {transform: scale(1);
opacity: 0.8;}
100% {transform: scale(3);
opacity: 0;}}@keyframes dash {to {stroke-dashoffset: -100;}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container42">
          <div className="your-global-representative-container43">
            <Script
              html={`<style>
        @keyframes pulse {0% {transform: scale(1);
opacity: 0.8;}
100% {transform: scale(3);
opacity: 0;}}
        </style> `}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container44">
          <div className="your-global-representative-container45">
            <Script
              html={`<script>
(function(){
  // Simple interaction to highlight map nodes on hover of text or other triggers
  const nodes = document.querySelectorAll(".floating-data-node")
  nodes.forEach((node) => {
    node.addEventListener("mouseenter", () => {
      node.style.transform = "scale(1.1)"
      node.style.borderColor = "var(--color-accent)"
    })
    node.addEventListener("mouseleave", () => {
      node.style.transform = "scale(1)"
      node.style.borderColor = "rgba(255, 255, 255, 0.1)"
    })
  })
})()
</script>`}
            ></Script>
          </div>
        </div>
        <div className="your-global-representative-container46">
          <div className="your-global-representative-container47">
            <Script
              html={`<style>
        @keyframes pulse {0% {transform: scale(1);
opacity: 0.8;}
100% {transform: scale(3);
opacity: 0;}}
        </style> `}
            ></Script>
          </div>
        </div>
      </section>
      <div className="your-global-representative-container48">
        <div className="your-global-representative-container49">
          <Script
            html={`<style>
        @keyframes pulse-glow {0% {box-shadow: 0 0 0 0 color-mix(in oklab, var(--color-accent) 50%, transparent);}
70% {box-shadow: 0 0 0 15px transparent;}
100% {box-shadow: 0 0 0 0 transparent;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="your-global-representative-container50">
        <div className="your-global-representative-container51">
          <Script
            html={`<script>
(function(){
  // Interaction for the comparison visual to add a slight tilt effect
  const cards = [document.querySelector(".client-side"), document.querySelector(".agent-side")]

  if (window.innerWidth > 991) {
    cards.forEach((card) => {
      if (!card) return

      card.addEventListener("mousemove", (e) => {
        const rect = card.getBoundingClientRect()
        const x = e.clientX - rect.left
        const y = e.clientY - rect.top

        const centerX = rect.width / 2
        const centerY = rect.height / 2

        const rotateX = (y - centerY) / 20
        const rotateY = (centerX - x) / 20

        card.style.transform = \`perspective(1000px) rotateX(\${rotateX}deg) rotateY(\${rotateY}deg) translateY(-10px)\`
      })

      card.addEventListener("mouseleave", () => {
        card.style.transform = \`perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0px)\`
      })
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default YourGlobalRepresentative
